import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.ProductPricingPlan.Delete.IRequest;
type Response = Api.Core.ProductPricingPlan.Delete.IResponse;
type Headers = Api.Core.ProductPricingPlan.Delete.IHeaders;
const url = '/api/ProductManagement/ProductPricingPlan/:id';
export default async function productPricingPlanDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
